// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-dialog{overflow-x:hidden}.v-dialog.v-dialog--active::-webkit-scrollbar{width:8px}.v-dialog.v-dialog--active::-webkit-scrollbar-track{background:transparent}.v-dialog.v-dialog--active::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.412);border:1px solid #a5a5a5;border-radius:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
